<template>
  <div class="article-most-viewed__wrapper">
    <section-title>Most Viewed</section-title>

    <ul>
      <li
        v-for="article in articles"
        :key="article.id"
        class="article-most-viewed__list-item"
      >
        <article-slot :article="article" />
      </li>
    </ul>
  </div>
</template>
<script>
import { PROP_TYPES, propValidator } from '@/utils/validators'
import ArticleSlot from 'shared/ArticleSlots/Fm/Shared/AArticleSlotMostViewed'
import SectionTitle from '../SectionTitle'

export default {
  name: 'SidebarMostViewed',
  components: { ArticleSlot, SectionTitle },
  props: {
    articles: propValidator([PROP_TYPES.ARRAY])
  },
  mounted() {
    this.$emit('mounted')
  }
}
</script>
<style scoped lang="scss">
.article-most-viewed__wrapper {
  .article-most-viewed__list-item {
    margin-bottom: 20px;

    &:last-child {
      margin-bottom: 0;
    }
  }
}
</style>
